import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconsModule } from '../icons/icons.module';
import { TooltipComponent } from './component/tooltip.component';
import { TooltipDirective } from './directive/tooltip.directive';
import { FocusOutDirectiveModule } from '../../directives/focus-out/focus-out.directive.module';
import { TrapFocusModule } from '../../directives/trap-focus';

@NgModule({
  declarations: [TooltipComponent, TooltipDirective],
  imports: [CommonModule, IconsModule, FocusOutDirectiveModule, TrapFocusModule],
  exports: [TooltipComponent, TooltipDirective],
})
export class TooltipModule {}
